// T052 — Share clicked event definition.

import type { EventDefinition } from './navigation';

export type ShareClickedProperties = {
  marketPubkey: string;
  method: 'copy' | 'native';
};

export const SHARE_CLICKED: EventDefinition<ShareClickedProperties> = {
  name: 'share_clicked',
};
